import PermissionChecker from '@/security/permission-checker';
import Permissions from '@/security/permissions';

export class ApplicationsPermissions {
    constructor(currentUser) {
        const permissionChecker = new PermissionChecker(
            currentUser,
        );

        this.read = permissionChecker.match(
            Permissions.values.applicationsRead,
        );
        this.create = permissionChecker.match(
            Permissions.values.applicationCreate,
        );
        this.view = permissionChecker.match(
            Permissions.values.applicationsView,
        );
        this.readStaff = permissionChecker.match(
            Permissions.values.applicationsStaffRead,
        );
        this.createDoc = permissionChecker.match(
            Permissions.values.createDoc
        );
        this.edit = permissionChecker.match(
            Permissions.values.applicationEdit,
        );
        this.readOwnStaff = permissionChecker.match(
            Permissions.values.applicationsStaffOwnRead,
        );
        this.assignApplication = permissionChecker.match(
            Permissions.values.applicationsStaffAssignEdit
        );
        this.viewPayments = permissionChecker.match(
            Permissions.values.paymentRegistryRead
        );
        this.recordPayments = permissionChecker.match(
            Permissions.values.paymentsRecordEdit
        );
        this.checkPayments = permissionChecker.match(
            Permissions.values.paymentsBankCheckEdit
        );
        this.viewPredefinedReports = permissionChecker.match(
            Permissions.values.predefinedReportsRead
        );
        this.createPredefinedReports = permissionChecker.match(
            Permissions.values.predefinedReportsCreate
        );
        this.editPredefinedReports = permissionChecker.match(
            Permissions.values.predefinedReportsEdit
        );
        this.responseDueDaysEdit = permissionChecker.match(
            Permissions.values.responseDueDaysEdit
        );
        this.createCircularNotifications = permissionChecker.match(
            Permissions.values.circularNotificationsCreate
        );
        this.registerApplication = permissionChecker.match(
            Permissions.values.organisationsApplicationsRegisterRead
        );
        this.digitizeApplication = permissionChecker.match(
            Permissions.values.organisationsApplicationsDigitizeRead
        );
    }
}
